import React from "react";
import { Modal } from "react-bootstrap";
import { url } from "../../utils/url";
import "../../App.css";
import { useHistory } from "react-router-dom";
import UserContext from "../../UserContext";

export default function ShowLikesModal(props) {
  const history = useHistory();

  const { mode } = React.useContext(UserContext);
  const [dark, setDark] = React.useState(false);

  React.useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable="true"
      className={dark && "special_modal"}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter h6">
          <h1 className="text-sm font-bold"> {props.title || "Fires"}</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        {props.users?.length === 0 && <p>Results will show up here</p>}
        {props.users?.map((user, index) => {
          return (
            <div
              key={user?._id || index}
              className={"flex mb-3 items-center justify-between "}
              style={{
                alignItems: "center",
              }}
            >
              <div
                className="flex gap-3 items-center cursor-pointer text-black hover:text-black flex-1"
                // onClick={() => history.push(`/users/${user?.username}`)}
              >
                <img
                  src={`${user?.image ? user.image : url + user?.profile?.url}`}
                  alt="profile pic"
                  className="mr-2 h-12 rounded-full"
                  style={{
                    height: "60px",
                    width: "60px",
                    objectFit: "cover",
                  }}
                  onClick={() => history.push(`/users/${user?.username}`)}
                ></img>
                <div className="p-0 flex gap-0  flex-col text-left">
                  <span
                    className={
                      "p-0 flex gap-1 text-sm font-bold hover:underline " +
                      (dark ? " text-white " : " text-black ")
                    }
                    onClick={() => history.push(`/users/${user?.username}`)}
                  >
                    {user?.names}
                    {user?.account_type === "VERIFIED" && (
                      <span title="Account verified">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          width="20"
                          height="20"
                        >
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path
                            d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z"
                            fill="rgba(249,2,2,1)"
                          />
                        </svg>
                      </span>
                    )}
                  </span>
                  <span className="p-0 text-xs text-muted">
                    {user?.username}
                  </span>
                </div>
              </div>
              {!props.user?.info?.followings?.includes(user?._id) &&
                user?._id !== props.user?.info?._id && (
                  <button
                    className="text-xs  font-mono italic hover:text-white hommy--btn rounded px-2 py-1 mr-3 hover:opacity-80 no-underline"
                    disabled={props.sendingRequest === user?._id}
                    onClick={() => props.addhommie(user._id)}
                  >
                    {props.sendingRequest === user?._id ? "Wait..." : "Hommy"}
                  </button>
                )}
            </div>
          );
        })}
      </Modal.Body>
      {/* <Modal.Footer>
        <button className="btn bg-fire upda-btn" onClick={props.onHide}>
          Close
        </button>
      </Modal.Footer> */}
    </Modal>
  );
}
